import { render, staticRenderFns } from "./ChemCartButton.vue?vue&type=template&id=c748b4fe"
import script from "./ChemCartButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChemCartButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports